import { IRequesterInfo } from "../../../../../base/models"
import { ClientProxy } from "../../../../../base/proxy/clientProxy"
import { IDealerSubTypeRequestModel, IDealerSubTypeResponseModel } from "../models/model"


export class GetDealerSubTypeListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/dealerSubTypeList',
      requesterInfo,
    })
  }

  public async getDealers(req: IDealerSubTypeRequestModel): Promise<IDealerSubTypeResponseModel[]> {
    return await this.postAsync<IDealerSubTypeResponseModel[]>(req)
  }
}